import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

interface InfoItem {
  icon: React.ReactNode;
  text: string;
}

interface AirshipInfoCardProps {
  ownerItems?: InfoItem[];
  technicianItems?: InfoItem[];
}

const iconBoxStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '2rem',
  width: '2rem',
  minHeight: '2rem',
  minWidth: '2rem',
  maxHeight: '2rem',
  maxWidth: '2rem',
};

const AirshipInfoCard: React.FC<AirshipInfoCardProps> = ({
  ownerItems = [],
  technicianItems = [],
}) => (
  <Box
    sx={{
      width: '100%',
      height: '100%',
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    }}
  >
    <Box
      sx={{
        maxWidth: '40rem',
        display: 'flex',
        gap: 4,
        flexDirection: 'column',
      }}
    >
      <Typography variant={'h2'} gutterBottom>
        Airship is the leading sales tool for your HVAC business.
      </Typography>
      <Box sx={{ display: 'flex', gap: 4, flexDirection: ['column', 'row'] }}>
        <Box sx={{ display: 'flex', gap: 3, flexDirection: 'column' }}>
          <Typography variant="h4" gutterBottom>
            For Business Owners
          </Typography>
          {ownerItems.map((item, idx) => (
            <Typography
              key={idx}
              variant={'body2'}
              component={'div'}
              sx={{ display: 'flex', gap: 1 }}
            >
              <Box sx={iconBoxStyle}>{item.icon}</Box>
              {item.text}
            </Typography>
          ))}
        </Box>
        <Box sx={{ display: 'flex', gap: 3, flexDirection: 'column' }}>
          <Typography variant="h4" gutterBottom>
            For Field Technicians
          </Typography>
          {technicianItems.map((item, idx) => (
            <Typography
              key={idx}
              variant={'body2'}
              component={'div'}
              sx={{ display: 'flex', gap: 1 }}
            >
              <Box sx={iconBoxStyle}>{item.icon}</Box>
              {item.text}
            </Typography>
          ))}
        </Box>
      </Box>
    </Box>
  </Box>
);

export default AirshipInfoCard;
